import {Groups} from 'Event/attendee'

import {
  GroupRule,
  IS_BLANK,
  IS_FILLED,
  IS_NOT,
} from 'Event/attendee-rules/RuleConfig/RuleList/SingleRule/GroupRule'

export function matchesGroupRule(groups: Groups, rule: GroupRule) {
  const groupKey = Object.keys(groups).find((key) => matchesGroupKey(key, rule))
  const value = groupKey === undefined ? undefined : groups[groupKey]
  const group = typeof value === 'string' ? value.toLowerCase() : value
  const groupRule = rule.target?.toLowerCase()

  if (rule.type === IS_NOT) {
    return group !== groupRule
  }

  if (rule.type === IS_FILLED) {
    return Boolean(group)
  }

  if (rule.type === IS_BLANK) {
    return !group
  }

  return group === groupRule
}

export function matchesGroupKey(key: string, rule: GroupRule) {
  return key.toLowerCase() === rule.key.toLowerCase()
}
